import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    const rawId = useId()
    const gradientId = `logo-core-${rawId.replace(/[^a-zA-Z0-9_-]/g, '')}`

    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            aria-hidden='true'
            className={cn('shrink-0', className)}
        >
            <defs>
                <radialGradient id={gradientId} cx='0.36' cy='0.32' r='0.78'>
                    <stop offset='0' stopColor='#9aa8ff' />
                    <stop offset='0.55' stopColor='#2f49ff' />
                    <stop offset='1' stopColor='#1a2ab8' />
                </radialGradient>
            </defs>

            <g transform='rotate(-24 16 16)'>
                <ellipse cx='16' cy='16' rx='14' ry='5.2' stroke='currentColor' strokeWidth='1.8' />
            </g>

            <circle cx='16' cy='16' r='7.4' fill={`url(#${gradientId})`} />

            <g transform='rotate(-24 16 16)'>
                <path d='M2 16 A14 5.2 0 0 0 30 16' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' />
            </g>
        </svg>
    )
}
